type Selected = { id: number } | undefined | null;

type AgreementToShowInput = {
    agreementKey: number;
    brokerAgreementKey: number;
    planOnlyBrokerAgreementKey: number;
    selectedBrokerAgent: Selected;
    selectedBrokerFirm: Selected;
};

export type AgreementToShow =
    | { kind: 'broker-firm'; brokerAgentId: number; brokerFirmId: number; planOnly: boolean }
    | { kind: 'template'; agreementKey: number };

export function agreementToShow({
    agreementKey,
    brokerAgreementKey,
    planOnlyBrokerAgreementKey,
    selectedBrokerAgent,
    selectedBrokerFirm
}: AgreementToShowInput): AgreementToShow {
    const isBrokerAgreement =
        agreementKey === brokerAgreementKey || agreementKey === planOnlyBrokerAgreementKey;

    if (isBrokerAgreement && selectedBrokerAgent && selectedBrokerFirm) {
        return {
            kind: 'broker-firm',
            brokerAgentId: selectedBrokerAgent.id,
            brokerFirmId: selectedBrokerFirm.id,
            planOnly: agreementKey === planOnlyBrokerAgreementKey
        };
    }

    return { kind: 'template', agreementKey };
}
